import React, { useEffect } from 'react';
// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
// import Footer from "../../components/footer/Footer.tsx";
import {useState} from "react";
import {calculateDiscountedPrice, formatISODate, formatPrice} from "../../utils/functions.tsx";
import { getFetcher, postFetcher, putFetcher } from '../../../api/fetchers.ts';
import { endpoints } from '../../../api/endpoints.ts';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../components/spinner/Spinner.tsx';
import { IoCloseSharp } from 'react-icons/io5';
import { Tooltip } from "flowbite-react";
import { useUser } from '../../context/UserContext.tsx';
import { useCurrency } from '../../context/CurrencyContext.tsx';
import { useLanguage } from '../../context/LanguageContext.tsx';

interface Order {
    id: string;
    orderNumber: string;
    userId: string;
    basketId: string;
    supplierId: string;
    dealerId: string;
    customerName: string;
    customerPhone: string;
    customerEmail: string;
    city: string;
    district: string;
    couponCode: string | null;
    deliveryStatus: number;
    deliveryAddress: string;
    deliveryNumber: string;
    deliveryDate: string;
    status: boolean;
    updatedAt: string;
    createdAt: string;
    totalAmount: string;
    productInfo: {
        productId: string;
        images: string;
        productName: string;
        productPrice: number;
        quantity: number;
    };
    supplierInfo: {
        supplierId: string;
        supplierName: string;
        supplierSurName: string;
        supplierMarketPlaceName: string;
    };
}

interface B2B {
    id: string;
    name: string;
    ratio: number;
}


const LastOrders: React.FC = () => {
    const { t } = useLanguage();
    const { exchangeRate } = useCurrency();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [selectedOrder, setSelectedOrder] = useState<any | null>(null);
    const [orders, setOrders] = useState<Order[]>([]);
    const [basketIds, setBasketIds] = useState<string[]>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [quantityModal, setQuantityModal] = useState(false);
    const [quantity, setQuantity] = useState<any>({});
    const [userBusinessPackage, setUserBusinessPackage] = useState<B2B>();
    const {user} = useUser();




    // FETCH LAST ORDERS
    useEffect(() => {

        const fetchBusinessPackageData = async () => {
            if (user) {
                try {
                    const businessPackage = await getFetcher(endpoints.user.getBusinessPackageById.replace('{id}', user.businessPackageId));
                    if (businessPackage.result) {
                        setUserBusinessPackage(businessPackage.businessPackage);
                    }
                } catch (error) {
                    console.error('Error fetching favorites:', error);
                }
            }
        }

        setLoading(true);
        const fetchLastOrders = async () => {
            try {
                const response = await getFetcher(endpoints.orders.getOrdersByUserId);
                if (response.result) {
                    const sortedOrders = response.orders.sort(
                        (a: Order, b: Order) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                    );
                    const lastTenOrders = sortedOrders.slice(0, 10);
                    setOrders(lastTenOrders);
                    setLoading(false);
                } else {
                    console.error('Failed to fetch last orders:', response);
                }
            } catch (error) {
                console.error('Failed to fetch last orders:', error);
            }
        };
        fetchLastOrders();

        fetchBusinessPackageData();
    }, []);

    // Order groups
    const orderGroups: any[] = orders.map((group: any) => ({
        date: formatISODate(group.map((item: any) => {
            return new Date(item.createdAt);
        })),
        orders: group,
    }));

    // OPEN MODAL
    const openModal = (order: any) => {
        // setBasketIds(order.map((item: any) => item.basketId));
        setSelectedOrder(order);
        setIsModalOpen(true);
    };

    // CLOSE MODAL
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedOrder(null);
    };

    // ORDER REPEAT
    const handleConfirm = async () => {

        try {
            if (selectedOrder) {
                const response = await postFetcher(endpoints.orders.createOrder, {
                    arg: {
                        basketIds: basketIds,
                        customerName: selectedOrder[0].customerName,
                        customerPhone: selectedOrder[0].customerPhone,
                        customerEmail: selectedOrder[0].customerEmail,
                        city: selectedOrder[0].city,
                        district: selectedOrder[0].district,
                        couponCode: selectedOrder[0].couponCode,
                        totalAmount: selectedOrder[0].totalAmount,
                        deliveryAddress: selectedOrder[0].deliveryAddress,
                    },
                });
                if (response.result) {
                    toast.success(t('toastMessage', 'rate12'));
                    setTimeout(() => {
                        navigate('/profile/orders');
                    }, 2000);
                }
            }
        } catch (error) {
            console.log(error);
        }
        closeModal();
    };

    // CALCULATE ITEM PRICE
    const calculateItemTotalPrice = (item: any): any => {
        const discountedPrice = calculateDiscountedPrice(item.productInfo.price, item.productInfo.discount, userBusinessPackage ? userBusinessPackage?.ratio : 0,exchangeRate );

        let totalPrice = discountedPrice * item?.basket?.quantity;

        if (item.basket.bulkDiscount) {
            const bulkDiscountedPrice = parseFloat(calculateBulkDiscount(item));
            totalPrice = bulkDiscountedPrice;
        }

        if (item.campaignInfo) {
            if (item.campaignInfo.dailyCampaign && item.campaignInfo.dailyCampaign.dailyCampaignTypeId == 3) {
                totalPrice -= item.campaignInfo.dailyCampaign.dailyValue * item.basket.quantity;
            }

            if (item.campaignInfo.companyCampaign && item.campaignInfo.companyCampaign.companyCampaignTypeId == 3) {
                totalPrice -= item.campaignInfo.companyCampaign.companyValue * item.basket.quantity;
            }
        }

        return totalPrice;
    };

    // CALCULATE BULKDISCOUNT
    const calculateBulkDiscount = (item: any) => {
        const bulkDiscounts = item.productInfo.bulkDiscounts ? item.productInfo.bulkDiscounts : [];
        const discountPrice = calculateDiscountedPrice(item.productInfo.price, item.productInfo.discount, userBusinessPackage ? userBusinessPackage?.ratio : 0,exchangeRate );

        if (item.basket.bulkDiscount) {
            const applicableBulkDiscount = bulkDiscounts
                .filter((bulk: any) => item?.basket?.quantity >= bulk?.quantity)
                .sort((a: any, b: any) => b?.basket?.quantity - a?.quantity)[0];

            if (applicableBulkDiscount) {
                const totalPrice = discountPrice * item?.basket?.quantity;
                const totalDiscountAmount = applicableBulkDiscount.discount * item?.basket?.quantity;
                const bulkPrice = (totalPrice - totalDiscountAmount).toFixed(2);
                return bulkPrice;
            } else {
                return (discountPrice * item?.basket?.quantity).toFixed(2);
            }
        } else {
            return (discountPrice * item?.basket?.quantity).toFixed(2);
        }
    };
    



    // TOTAL PRICE
    const calculateTotalPrice = (item: any) => {
        let totalPrice: number = item?.reduce((sum: any, item: any) => sum + calculateItemTotalPrice(item), 0) || 0;
        return totalPrice;
    };

  
    if (loading) {
        return <div className="spinner-container"><Spinner/></div>;
    }


    const textCut = (text: string, length: number) => {
        if (text.length > length) {
            return text.substring(0, length) + '...';
        } else {
            return text;
        }
    }


    const handleClickQuantityModal = (order: any) => {
        setQuantityModal(!quantityModal);
        setSelectedOrder(order);
        if (Array.isArray(order) && order.length > 0) {
            const initialQuantities = order.reduce((acc: any, item: any) => {
                acc[item.basket.productId] = item.basket.quantity;
                return acc;
            }, {});
            setQuantity(initialQuantities);
        }
    };


    const handleChange = (e: any, productId: any) => {
        const { value } = e.target;
        setQuantity((prevQuantities: any) => ({
            ...prevQuantities,
            [productId]: value,
        }));
    };

    const handleClickQuantityConfirm = async (item: any) => {
        setQuantityModal(false);

        try {
            setBasketIds([]);
            const response = await putFetcher(endpoints.user.updateLastOrders, {
                arg: {
                    productIds: item.map((item: any) => item.basket.productId),
                    quantities: item.map((item: any) => quantity[item.basket.productId]),
                }
            });
    
            if (response.result) {
                toast.success('Success');
                const updatedQuantities = item.reduce((acc: any, currItem: any) => {
                    const productId = currItem.basket.productId;
                    const newQuantity = quantity[productId];
                    return { ...acc, [productId]: newQuantity };
                }, {});
            
                setQuantity((prevQuantities: any) => ({
                    ...prevQuantities,
                    ...updatedQuantities, 
                }));
                let basketIds:any = [];
                response.basketItem.map((item: any) => {
                    basketIds.push(item.id);
                });
                setBasketIds(basketIds);
            } else {
                toast.error('Error');
            }
        } catch (error) {
            console.log(error);
            toast.error('Error');
        }
    };
    
    let content;



    

    if(quantityModal) {
        content = (
            <div>
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg w-1/2 lg:w-1/3">
                        <div className="p-4 border-b flex justify-between items-center">
                            <h2 className="text-xl font-bold">Adet Değiştir</h2>
                            <button className="text-gray-700" onClick={handleClickQuantityModal}><IoCloseSharp/></button>
                        </div>
                        <div className="p-4">
                            <div>
                                {   
                                    selectedOrder.map((item: any, index: any) => {
                                        return(
                                            <ul key={index} className=' flex justify-start items-center flex-col xl:flex-row  gap-x-10 gap-y-3 border-b p-2'>
                                                <img src={item.productInfo.images[0]} alt={item.productInfo.productName} className=' w-9 h-9 ' />
                                                <li className=' font-light text-sm lg:min-w-60' key={index}>{textCut(item?.productInfo?.productName, 30)}</li> 
                                                <li key={index} className=' flex justify-center xl:justify-end items-center cursor-pointer select-none w-full'>
                                                <Tooltip content="Adet Değiştir">
                                                    <input onChange={(e) => handleChange(e, item.basket.productId)} type="text" value={quantity[item.basket.productId || '']} name='quantity'  className=' w-[63px] min-w-[63px] h-5 p-2 font-semibold bg-gray-100 text-black text-center border-none rounded-full object-none'/>
                                                </Tooltip>
                                                </li> 
                                            </ul>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className=' flex justify-end px-4 py-2'>
                                <button onClick={() => handleClickQuantityConfirm(selectedOrder)} className=' bg-green-600 p-1 font-semibold rounded active:scale-95 transform transition-all text-white'>Onayla</button>
                        </div>
                    </div>
                </div>
            </div>    
        )
    }else {
        content = null;
    }
    return (
        <div className="flex flex-col min-h-screen">
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover/>
            {/* <Header/>
            <Navbar/> */}
            <main className="flex-grow p-4 mb-20 md:p-8 w-4/5 lg:w-4/6 mx-auto">
                <h1 className="text-3xl md:text-4xl text-primary-color font-bold my-6 text-center">GEÇMİŞ
                    SİPARİŞLERİM</h1>
                <h2 className="text-2xl md:text-3xl text-center md:text-left text-color-opacity mb-6">
                    Son 10 Siparişiniz
                </h2>

                {
                    loading ? (<Spinner />) : orderGroups.length === 0 ? (
                        <div className="flex justify-center items-center h-96">
                            <p className="text-xl text-gray-500">Henüz sipariş geçmişiniz bulunmamaktadır.</p>
                        </div>
                    ): (
                        <div className="space-y-6">
                        {orderGroups.map((group, index) => (
                            <div key={index} className="border border-gray-400 rounded-lg p-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                                    <div>
                                        <span className="font-semibold block text-center">Sipariş Tarihi</span>
                                        <span className="font-semibold text-primary-color block text-center">
                                    {formatISODate(group.orders[0].createdAt)}
                                </span>
                                    </div>
                                    <div>
                                        <span className="font-semibold block text-center">Toplam Fiyat</span>
                                        <span className="font-semibold text-primary-color block text-center">
                                    {formatPrice(calculateTotalPrice(group.orders))} 
                                </span>
                                    </div>
                                    <div>
                                        <span className="font-semibold block text-center">Sipariş Özeti</span>
                                        <span className="font-semibold text-green-600 block text-center">
                                    {group.orders.length} ürün sipariş edildi
                                </span>
                                    </div>
                                    <div>
                                        <span className="font-semibold block text-center">Firma Adı</span>
                                        <span className="font-semibold text-primary-color block text-center">
                                    {group.orders[0]?.supplierInfo ? group.orders[0].supplierInfo.supplierMarketPlaceName : "Novamed"}
                                </span>
                                    </div>
                                </div>

                                <div className="relative flex flex-col items-center md:items-start lg:pl-16 pt-8">
                                    <div className="max-h-64 overflow-y-auto mb-4">
                                        <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                                            {group.orders.map((order: any, idx: any) => (
                                                <div key={idx}
                                                    className="w-36 sm:w-40 border border-gray-300 rounded-lg shadow-md bg-white overflow-hidden cursor-pointer relative"
                                                    onClick={() => navigate(`/product-detail/${order.productInfo.productId}`)}
                                                    >
                                                    <div className="h-24 overflow-hidden">
                                                        <img src={(order.productInfo.images)[0]} alt="Product"
                                                            className="w-full h-full object-contain transition-transform duration-300 hover:scale-105 pt-2"/>
                                                    </div>
                                                    <div className="p-2">
                                                        <p className="text-xs truncate">{order.productInfo.productName}</p>
                                                        <div className="flex justify-end gap-x-5 items-center mt-1">
                                                            <span className="block font-semibold text-xs text-primary-color">{formatPrice(order?.basket.bulkDiscount == true ? calculateBulkDiscount(order) :  calculateItemTotalPrice(order))}</span>
                                                        </div>
                                                    </div>

                                                    <div className=' border w-7 h-7 rounded-full bg-primary-color text-white top-0 right-0 absolute flex justify-center items-center p-1 text-[12px] font-semibold'>{quantity && quantity[order.productInfo.productId] !== undefined ? quantity[order.productInfo.productId] : order.basket.quantity}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-4 self-center md:self-end w-5/6 md:w-1/5 flex justify-center items-center flex-col gap-y-3 ">
                                            <button onClick={() => handleClickQuantityModal(group.orders)} className='border border-primary-color bg-primary-color w-full text-white rounded-lg px-4 py-2 active:scale-95 transition hover:bg-opacity-80'>Adeti Değiştir</button>
                                        <button
                                            onClick={() => openModal(group.orders)}
                                            className="border border-green-600 bg-green-600 w-full text-white rounded-lg px-4 py-2 active:scale-95 transition hover:bg-opacity-80"
                                        >
                                            Siparişi Tekrarla
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </div>
                    )
                }
            </main>
            {/* <Footer/> */}
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg w-1/2 md:w-1/3 lg:w-1/5">
                        <div className="p-4 border-b flex justify-between items-center">
                            <h2 className="text-xl font-bold">Siparişi Tekrarla</h2>
                            <button className="text-gray-700" onClick={closeModal}>X</button>
                        </div>
                        <div className="p-4">
                            <p>Siparişi tekrar etmek istediğinizden emin misiniz?</p>
                            <div className="mt-4 flex justify-end gap-2 flex-col">
                                <button onClick={handleConfirm}
                                        className="bg-green-700 text-white px-4 py-2 rounded active:scale-95 transition hover:bg-opacity-80">Evet
                                </button>
                                <button onClick={closeModal}
                                        className="bg-primary-color text-white px-4 py-2 rounded active:scale-95 transition hover:bg-opacity-80">Hayır
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {
                quantityModal && (
                    content
                )
            }
        </div>
    );
};

export default LastOrders;
